import { HOME_BANNER } from "../../constants/seller-constant";

export const getBannerImage = (data = {}, category = "", customBannerMapping = {}) => {
    return (data && data.image) || (customBannerMapping && customBannerMapping[category]) || HOME_BANNER[category];
};
